module.exports = __webpack_public_path__ + "img/pay_off.7c1d5ce5.svg";